export const version = "strings/5.2.0";
//# sourceMappingURL=_version.js.map